import api from './api';

/**
 * Fetch products from the public API (paginated).
 * @param {Object} params - { page, per_page, search, status, featured }
 * @returns {Promise<{ data: Array, current_page, last_page, per_page, total }>}
 */
export const fetchProducts = async (params = {}) => {
  const searchParams = new URLSearchParams();
  if (params.page) searchParams.set('page', params.page);
  if (params.per_page) searchParams.set('per_page', params.per_page);
  if (params.search && params.search.trim()) searchParams.set('search', params.search.trim());
  if (params.status) searchParams.set('status', params.status);
  if (params.featured !== undefined && params.featured !== '') {
    searchParams.set('featured', params.featured ? '1' : '0');
  }
  const query = searchParams.toString();
  const endpoint = query ? `/products?${query}` : '/products';
  const { data } = await api.get(endpoint);
  return data;
};

/**
 * Fetch featured products for the homepage.
 */
export const fetchFeaturedProducts = async (limit = 8) => {
  const data = await fetchProducts({ featured: 1, per_page: limit });
  return data.data || [];
};

/**
 * Fetch a single product by id (public).
 */
export const fetchProduct = async (id) => {
  const { data } = await api.get(`/products/${id}`);
  return data;
};

/**
 * Search products by keyword.
 * @param {string} query
 */
export const searchProducts = async (query) => {
  if (!query || query.length < 2) return [];
  const { data } = await api.get(`/products/search?q=${encodeURIComponent(query)}`);
  return data;
};
